<template>
  <div
    :class="['wg-row', 'f-align-center', (row.onclick ? 'com-anm22-app-pointer' : ''), 'item-row']"
  >
    <div class="wg-row com-anm22-app-text-l" style="align-items:center;flex-wrap:nowrap;">
      <div class="wg-col wg-xs-8">
        <div class="wg-row" style="align-items:center;flex-wrap:nowrap;" @click="row.onclick ? row.onclick(row.elem) : ''">
          <div class="quantity">{{ row.quantity + 'x' }}</div>
          <div class="wg-row" style="flex-direction:column;">
            <div class="wg-row fc-art-name">
              <div>{{ row.elem.productName }}</div>
            </div>
            <div
              v-if="row.weight !== null"
              class="wg-row"
              style="align-items:center;flex-wrap:nowrap;color:#999;"
            >
              <div class="price com-anm22-app-text-m">
                {{ Number(row.weight) }}
                </div>
              <div class="com-anm22-app-text-m" style="margin-left:2px;">
                {{ $anm22.tableClasses.foodUnitOfMeasurement().getById(row.elem.productUom)['typeClassLiteral'] }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wg-col wg-xs-4">
        <div
          class="wg-row"
          style="margin-left:auto;align-items:center;flex-wrap:nowrap;justify-content:flex-end;cursor:default;"
        >
          <div class="price com-anm22-app-text-l">
            {{ Number(row.price).toFixed(2) }}
          </div>
          <div class="com-anm22-app-text-l" style="margin-left:2px;">€</div>
          <img
            v-if="row.deletable"
            :src="$anm22.icons.getWorldIcon('deleteRed')"
            class="com-anm22-app-pointer com-anm22-app-img-s"
            style="margin-left:5px;"
            @click="$emit('delete-article', row.elem.id)"
          >
        </div>
      </div>
    </div>
    <template v-if="row.elem.variations.length > 0">
      <div
        v-for="(_var,index) in row.elem.variations"
        :key="'var-'+row.elem.id+'-'+index"
        class="wg-row com-anm22-app-text-l"
        style="padding-left:23px;flex-wrap:nowrap;align-items:center;margin-top:4px;"
      >
        <div class="wg-col wg-xs-8">
          <div class="wg-row">
            <div >{{ _var.sign + ' ' + $anm22.food_getVariationName(lang, _var) }}</div>
          </div>
        </div>
        <div class="wg-col wg-xs-4">
          <div
            class="wg-row"
            :style="{
              marginRight: row.deletable ? '30px' : '',
              alignItems:'center',
              flexWrap: 'nowrap',
              justifyContent: 'flex-end',
              cursor:'default'
            }"
          >
            <div>
              {{ Number(_var.price).toFixed(2) }}
            </div>
            <div style="margin:0 25px 0 2px;">€</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    row: Object
  },
  data: function() {
    return {};
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  }
};
</script>

<style lang="scss" scoped>
.item-row {
  margin-top: 12px;
}
.price-sub-zero {
  background-color: red;
  color: #fff;
}
.quantity {
  margin-right: 5px;
}
</style>
